import type { ErrorType } from '@/Pages/Error/types/errorLocationState';
import { ApiError } from '@/basedata/apiCall';

function isNetworkError(error: unknown): boolean {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return true;
  }
  if (error instanceof TypeError) {
    return true;
  }
  if (error instanceof Error && error.message.includes('Failed to fetch')) {
    return true;
  }
  return false;
}

export function resolveErrorType(error: unknown): ErrorType {
  if (error === undefined || error === null) {
    return 'generic';
  }

  if (isNetworkError(error)) {
    return 'network';
  }

  if (error instanceof ApiError) {
    if (error.status === 401 || error.status === 403) {
      return 'auth';
    }
    if (error.status === 404) {
      return 'not_found';
    }
    // 409 no cadastro = convidado já tem biometria (o service recusa recobrar).
    if (error.status === 409) {
      return 'already_onboarded';
    }
    if (error.status >= 500) {
      return 'server';
    }
    return 'generic';
  }

  return 'generic';
}
